/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 21:28:09
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer, IViewDate } from 'src/types/base';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import DatePicker from 'src/types/iview/DatePicker';
import MaintenanceRecordApi, { MaintenanceRecordDOI } from './api/maintenanceRecordApi';
import Upload from 'src/types/iview/Upload';
import { createNamespace } from 'src/util/bem';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';

export namespace OperateMaintenanceRecordVOI {
    export interface PropsI {
        operate: string;
        id: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        accessory: string;
        dispose_site: Integer;
        dispose_type: Integer;
        dispose_people: string;
        dispose_datetime: IViewDate;
        dispose_content: string;
    }
}

@Component
class OperateMaintenanceRecordModal extends Vue.Component<OperateMaintenanceRecordVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    uploading: boolean = false;

    formData: OperateMaintenanceRecordVOI.FormDataI = {
        accessory: '',
        dispose_site: null,
        dispose_type: null,
        dispose_people: '',
        dispose_datetime: '',
        dispose_content: '',
    };
    rules: any = {};

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }
    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            this.formData.accessory=res.data.url
        } 
    }
    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        let params:MaintenanceRecordDOI.OperateParamsI = {
            ...this.formData,
            dispose_datetime: DateTimeUtil.formateDate(this.formData.dispose_datetime)
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await MaintenanceRecordApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id;
                res = await MaintenanceRecordApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        if(this.operate === EnumOperates.Update.getName()) {
            let {code, data} = await MaintenanceRecordApi.searchDetail({id: this.id})
            if(code === 0) {
                this.formData = {
                    ...data,
                    dispose_datetime: new Date(data.dispose_datetime),
                    dispose_type: data.dispose_type_id
                }
            }
        }
    }

    render(h) {
        return (
            <Modal title={this.operate + '运维记录'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={120} model={this.formData} rules={this.rules}>
                    <form-item label="运维/处理站点" prop="dispose_site" required type="number" style="display: inline-block;width:45%">
                        <EntitySelect type={EnumEntity.Station.getId()} v-model={this.formData.dispose_site} />
                    </form-item>
                    <form-item label="处理类型" prop="dispose_type" required type="number" style="display: inline-block;width:45%">
                        <EntitySelect type={EnumEntity.DeclareType.getId()} v-model={this.formData.dispose_type} />
                    </form-item>
                    <form-item label="处理人" prop="dispose_people" required style="display: inline-block;width:45%">
                        <Input placeholder="请输入" v-model={this.formData.dispose_people} />
                    </form-item>
                    <form-item label="处理时间" prop="dispose_datetime" required type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.dispose_datetime} />
                    </form-item>
                    <form-item label="处理内容" prop="dispose_content" required style="display: inline-block;width:90%">
                        <Input placeholder="请输入" v-model={this.formData.dispose_content} />
                    </form-item>
                    <form-item label="上传附件"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/ops/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            before-upload={() => {
                                this.uploading = true;
                            }}
                        >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                        </Upload>
                        <div class={createNamespace('upload-text')}>支持扩展名：.rar .zip .doc .docx .pdf .jpg</div>
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertOperateMaintenanceRecordModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<OperateMaintenanceRecordVOI.PropsI>(OperateMaintenanceRecordModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
